var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": _vm.modalId,
      "visible": _vm.visible,
      "size": "xl",
      "centered": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "modal-class": "media-picker-modal",
      "content-class": "media-picker-modal__content",
      "body-class": "media-picker-modal__body"
    },
    on: {
      "hide": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-title",
      fn: function () {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-between w-100 pr-1"
        }, [_c('div', [_c('h4', {
          staticClass: "mb-0"
        }, [_vm._v(_vm._s(_vm.title))]), _c('small', {
          staticClass: "text-muted"
        }, [_vm._v(" " + _vm._s(_vm.multiple ? 'Select one or more media items' : 'Select a single media item') + " ")])])])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "media-picker"
  }, [_c('div', {
    staticClass: "media-picker__main"
  }, [_c('div', {
    staticClass: "media-toolbar"
  }, [_c('div', {
    staticClass: "media-toolbar__tabs"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--tab",
    attrs: {
      "size": "sm",
      "variant": _vm.tab === 'library' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function ($event) {
        _vm.tab = 'library';
      }
    }
  }, [_vm._v(" Library ")]), _c('b-button', {
    staticClass: "media-btn media-btn--tab",
    attrs: {
      "size": "sm",
      "variant": _vm.tab === 'upload' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function ($event) {
        _vm.tab = 'upload';
      }
    }
  }, [_vm._v(" Upload ")])], 1), _vm.tab === 'library' ? _c('div', {
    staticClass: "media-toolbar__filters"
  }, [_c('b-input-group', {
    staticClass: "mr-1 media-search",
    attrs: {
      "size": "sm"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search media..."
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "search"
    }
  })], 1), _c('b-form-select', {
    staticClass: "mr-1 media-type-filter",
    attrs: {
      "options": _vm.sourceOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.source,
      callback: function ($$v) {
        _vm.source = $$v;
      },
      expression: "source"
    }
  }), _c('b-form-select', {
    staticClass: "mr-1 media-type-filter",
    attrs: {
      "options": _vm.typeOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.type,
      callback: function ($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }), _c('b-form-select', {
    staticClass: "mr-1 media-type-filter",
    attrs: {
      "options": _vm.collectionOptions,
      "size": "sm"
    },
    on: {
      "change": _vm.onFilterChange
    },
    model: {
      value: _vm.collection,
      callback: function ($$v) {
        _vm.collection = $$v;
      },
      expression: "collection"
    }
  }), _c('b-button', {
    staticClass: "media-btn media-btn--ghost",
    attrs: {
      "size": "sm",
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.fetchLibrary
    }
  }, [_vm._v(" Refresh ")])], 1) : _vm._e()]), _vm.tab === 'upload' ? _c('div', {
    staticClass: "media-upload-tab"
  }, [_c('div', {
    staticClass: "media-dropzone",
    class: {
      'is-dragging': _vm.isDragging
    },
    on: {
      "dragenter": function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragover": function ($event) {
        $event.preventDefault();
        _vm.isDragging = true;
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        _vm.isDragging = false;
      },
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.handleDrop($event);
      }
    }
  }, [_c('div', {
    staticClass: "media-dropzone__inner"
  }, [_c('feather-icon', {
    staticClass: "mb-1 text-primary",
    attrs: {
      "icon": "UploadCloudIcon",
      "size": "34"
    }
  }), _c('h5', {
    staticClass: "mb-50"
  }, [_vm._v("Drop files here or browse")]), _c('p', {
    staticClass: "text-muted mb-1"
  }, [_vm._v(" Supports multiple files. Best for images. ")]), _c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.fileInput.click();
      }
    }
  }, [_vm._v(" Choose Files ")]), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "multiple": _vm.multipleUpload
    },
    on: {
      "change": _vm.handleFileInput
    }
  })], 1)]), _vm.uploadQueue.length ? _c('div', {
    staticClass: "mt-2"
  }, [_c('h6', {
    staticClass: "mb-1"
  }, [_vm._v("Selected for upload")]), _c('div', {
    staticClass: "upload-queue"
  }, _vm._l(_vm.uploadQueue, function (file, index) {
    return _c('div', {
      key: ((file.name) + "-" + index),
      staticClass: "upload-queue__item"
    }, [_c('div', {
      staticClass: "upload-queue__item-left"
    }, [_c('feather-icon', {
      staticClass: "mr-50",
      attrs: {
        "icon": "FileIcon",
        "size": "16"
      }
    }), _c('span', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(file.name))])], 1), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.formatFileSize(file.size)))])]);
  }), 0), _c('div', {
    staticClass: "mt-2 d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.uploadSelectedFiles
    }
  }, [_vm.isUploading ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isUploading ? 'Uploading...' : 'Upload Now') + " ")], 1), _c('b-button', {
    staticClass: "media-btn media-btn--ghost ml-1",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "disabled": _vm.isUploading
    },
    on: {
      "click": _vm.clearUploadQueue
    }
  }, [_vm._v(" Clear ")])], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "media-library-tab"
  }, [_c('div', {
    staticClass: "media-library-meta mb-1"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm.pagination.total ? _c('span', [_vm._v(" " + _vm._s(_vm.pagination.from || 0) + "-" + _vm._s(_vm.pagination.to || 0) + " of " + _vm._s(_vm.pagination.total) + " ")]) : _c('span', [_vm._v("No media found")])]), _vm.multiple ? _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v(" Selected: " + _vm._s(_vm.selectedItems.length) + " ")]) : _vm._e()]), _vm.isLoading ? _c('div', {
    staticClass: "media-grid-loading"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary"
    }
  })], 1) : _vm.mediaItems.length ? _c('div', {
    staticClass: "media-grid"
  }, _vm._l(_vm.mediaItems, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "media-grid__item",
      class: {
        'is-selected': _vm.isSelected(item),
        'is-active-preview': _vm.activePreview && _vm.activePreview.id === item.id
      },
      on: {
        "click": function ($event) {
          return _vm.handleMediaClick(item);
        },
        "dblclick": function ($event) {
          return _vm.quickSelect(item);
        },
        "contextmenu": function ($event) {
          $event.preventDefault();
          _vm.activePreview = item;
        }
      }
    }, [_c('div', {
      staticClass: "media-grid__thumb"
    }, [_vm.isImage(item) ? _c('img', {
      attrs: {
        "src": item.preview_url || item.original_url,
        "alt": item.file_name || item.name,
        "loading": "lazy"
      },
      on: {
        "error": _vm.handleImageError
      }
    }) : _c('div', {
      staticClass: "media-grid__file"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "FileTextIcon",
        "size": "26"
      }
    })], 1), _vm.isSelected(item) ? _c('div', {
      staticClass: "media-grid__check"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "CheckIcon",
        "size": "16"
      }
    })], 1) : _vm._e()]), _c('div', {
      staticClass: "media-grid__meta"
    }, [_c('div', {
      staticClass: "media-grid__name"
    }, [_vm._v(" " + _vm._s(item.file_name || item.name) + " ")]), _c('div', {
      staticClass: "media-grid__sub"
    }, [_vm._v(" " + _vm._s(_vm.humanMime(item.mime_type)) + " ")])])]);
  }), 0) : _c('div', {
    staticClass: "media-empty-state"
  }, [_c('feather-icon', {
    staticClass: "mb-1 text-muted",
    attrs: {
      "icon": "ImageIcon",
      "size": "34"
    }
  }), _c('h5', {
    staticClass: "mb-50"
  }, [_vm._v("No media found")]), _c('p', {
    staticClass: "text-muted mb-0"
  }, [_vm._v("Try uploading files or changing the search.")])], 1), _vm.pagination.total > _vm.pagination.per_page ? _c('div', {
    staticClass: "media-pagination mt-2"
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.pagination.total,
      "per-page": _vm.pagination.per_page,
      "first-number": "",
      "last-number": "",
      "size": "sm",
      "align": "center"
    },
    on: {
      "input": _vm.onPageChange
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1) : _vm._e()])]), _c('div', {
    staticClass: "media-picker__sidebar"
  }, [_c('div', {
    staticClass: "media-sidebar-card"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Details")]), _vm.activePreview ? _c('div', [_c('div', {
    staticClass: "media-sidebar-preview mb-1"
  }, [_vm.isImage(_vm.activePreview) ? _c('img', {
    attrs: {
      "src": _vm.activePreview.original_url || _vm.activePreview.preview_url,
      "alt": _vm.activePreview.file_name || _vm.activePreview.name
    },
    on: {
      "error": _vm.handleImageError
    }
  }) : _c('div', {
    staticClass: "media-sidebar-file-preview"
  }, [_c('feather-icon', {
    attrs: {
      "icon": "FileTextIcon",
      "size": "30"
    }
  })], 1)]), _c('ul', {
    staticClass: "media-sidebar-info list-unstyled mb-0"
  }, [_c('li', [_c('strong', [_vm._v("Name:")]), _c('span', [_vm._v(_vm._s(_vm.activePreview.file_name || _vm.activePreview.name || '--'))])]), _c('li', [_c('strong', [_vm._v("Type:")]), _c('span', [_vm._v(_vm._s(_vm.activePreview.mime_type || '--'))])]), _c('li', [_c('strong', [_vm._v("Collection:")]), _c('span', [_vm._v(_vm._s(_vm.activePreview.collection_name || '--'))])]), _c('li', [_c('strong', [_vm._v("Size:")]), _c('span', [_vm._v(_vm._s(_vm.formatFileSize(_vm.activePreview.size || 0)))])]), _c('li', [_c('strong', [_vm._v("ID:")]), _c('span', [_vm._v(_vm._s(_vm.activePreview.id))])])])]) : _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v(" Select a media item to preview its details. ")])]), _c('div', {
    staticClass: "media-sidebar-card mt-1"
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Selection")]), _vm.selectedItems.length ? _c('div', _vm._l(_vm.selectedItems, function (item) {
    return _c('div', {
      key: ("selected-" + (item.id)),
      staticClass: "media-selected-item"
    }, [_c('div', {
      staticClass: "media-selected-item__left"
    }, [_c('div', {
      staticClass: "media-selected-item__thumb"
    }, [_vm.isImage(item) ? _c('img', {
      attrs: {
        "src": item.preview_url || item.original_url,
        "alt": item.file_name || item.name
      },
      on: {
        "error": _vm.handleImageError
      }
    }) : _c('div', {
      staticClass: "media-selected-item__thumb-fallback"
    }, [_c('feather-icon', {
      attrs: {
        "icon": "FileTextIcon",
        "size": "14"
      }
    })], 1)]), _c('div', {
      staticClass: "media-selected-item__meta"
    }, [_c('div', {
      staticClass: "media-selected-item__name"
    }, [_vm._v(" " + _vm._s(item.file_name || item.name) + " ")]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.humanMime(item.mime_type)))])])]), _c('b-button', {
      staticClass: "btn-icon",
      attrs: {
        "size": "sm",
        "variant": "flat-danger"
      },
      on: {
        "click": function ($event) {
          return _vm.removeSelected(item);
        }
      }
    }, [_c('feather-icon', {
      attrs: {
        "icon": "XIcon",
        "size": "14"
      }
    })], 1)], 1);
  }), 0) : _c('div', {
    staticClass: "text-muted small"
  }, [_vm._v(" No media selected yet. ")])])])]), _c('div', {
    staticClass: "media-picker-footer"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm.multiple ? _c('span', [_vm._v(_vm._s(_vm.selectedItems.length) + " item(s) selected")]) : _c('span', [_vm._v(_vm._s(_vm.selectedItems.length ? '1 item selected' : 'No item selected'))])]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-button', {
    staticClass: "media-btn media-btn--ghost mr-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "media-btn media-btn--primary",
    attrs: {
      "variant": "primary",
      "disabled": !_vm.selectedItems.length
    },
    on: {
      "click": _vm.confirmSelection
    }
  }, [_vm._v(" " + _vm._s(_vm.confirmButtonText) + " ")])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }